import { createFeatureSelector, createSelector } from "@ngrx/store"
import { WishlistState } from "./wishlist.state";



export const selectWishlistFeature = createFeatureSelector<WishlistState>('wishlist');

export const selectWishlistProduct = createSelector(
    selectWishlistFeature,
 state => state.products
);




export const selectWishlistLoding =createSelector(
    selectWishlistFeature,
    (state) => state.loading
)




export const selectWishlistId = createSelector(
    selectWishlistFeature,
    state => state.ids
)
export const clearWishlistSuccess = createSelector(
    selectWishlistFeature,
    state => state.ids=[]
)